import axios from 'axios';

import { queryClient } from 'stateManagement/queries/client';

import { axiosErrorToast } from 'blockscope/utils/toastHandler';

/**
 * @param { import('./zod').BaseTracer} tracerObject
 */
export const createTracerEndpoint = async (tracerObject) => {
  const response = await axios.post(
    `/api/v2/tracer/`,
    { ...tracerObject },
    {
      headers: {
        'Content-Type': 'application/json',
      },
    }
  );
  return response.data.dataPayload.tracer;
};
/**
 * @param {import('./zod').BaseTracer} newTracer
 * @param {import('react-router-dom').SetURLSearchParams} setSearchParams
 */
export const createTracer_Mutation = async (newTracer, setSearchParams) => {
  try {
    const data = await createTracerEndpoint(newTracer);
    await queryClient.cancelQueries(['org', 'tracers']);
    queryClient.setQueryData(['org', 'tracers'], (oldTracerList) =>
      oldTracerList ? [data, ...oldTracerList] : oldTracerList
    );

    queryClient.setQueryData(['tracer', data._id], data);
    setSearchParams({ tracerId: data._id });
  } catch (err) {
    axiosErrorToast(err);
  }
};

/**
 * @param {import('./zod').BaseTracer &{tracerId:string}} tracerObject
 * @returns
 */
export const updateTracerEndpoint = async (tracerObject) => {
  const res = await axios.put(
    `/api/v2/tracer/${tracerObject.tracerId}`,
    { ...tracerObject },
    {
      headers: {
        'Content-Type': 'application/json',
      },
    }
  );
  return res.data.dataPayload;
};

/**
 * @param {import('./zod').BaseTracer &{tracerId:string}} tracerObject
 * @returns
 */
export const updateTracer_Mutation = async (tracerObject) => {
  try {
    const data = await updateTracerEndpoint(tracerObject);
    await queryClient.cancelQueries(['tracer', tracerObject.tracerId]);
    queryClient.setQueryData(['tracer', tracerObject.tracerId], () => {
      return data.updatedTracer;
    });
  } catch (err) {
    axiosErrorToast(err);
  }
};
